export const GET_LECTURES = "GET_LECTURES";
export const GET_LECTURE_BY_ID = "GET_LECTURE_BY_ID";
export const UPDATE_LECTURE = "UPDATE_LECTURE";
export const DELETE_LECTURE = "DELETE_LECTURE";
export const CREATE_LECTURE = "CREATE_LECTURE";
export const GET_LECTURE_MEDIA = "GET_LECTURE_MEDIA";
export const CREATE_LECTURE_MEDIA = "CREATE_LECTURE_MEDIA";
